import { Environment } from '@lx/shared/types';

// TODO: Create local type because of build error. Use environment from core.
export interface ApiPathOption {
  value: string;
  title: string;
  right?: string;
}

export const API_PATHS: Record<Environment, ApiPathOption> = {
  development: {
    value: 'https://api-dev.klgintdc.com/api',
    title: 'develop',
  },
  stage: {
    value: 'https://api-stage.klgintdc.com/api',
    title: 'stage',
  },
  production: {
    value: 'https://api-prod.klgintdc.com/api',
    title: 'prod',
    right: '⚠️',
  },
};
